<template>
  <div style="width: 100%;">
    <div class="inner-card">
      <div class="svg"><img src="@/assets/images/watch.svg" alt="" /></div>
      <stop-watch
        @time="receiveStopWatchTime"
        :stop="is_stopwatch_stop"
      ></stop-watch>
    </div>
    <!--No of Questions answered-->
    <div class="inner-card">
      <div class="svg"><img src="@/assets/images/que.svg" alt="" /></div>
      <div class="inner-card-content is-flex-grow-1">
        <p class="text">Questions Answered</p>
        <div class="que-ans">
          <span>{{ questionsAnswered }}</span
          >/<span>{{ fetchQuestions.length }}</span>
        </div>
      </div>
    </div>
    <!-- <div class="inner-card">
      <div class="svg"><img src="@/assets/images/que.svg" alt="" /></div>
      <div class="inner-card-content is-flex-grow-1">
        <p class="text">Questions Correct</p>
        <div class="que-ans">
          <span>{{ questionsCorrect }}</span
          >/<span>{{ fetchQuestions.length }}</span>
        </div>
      </div>
    </div> -->
    <div class="inner-card">
      <div class="svg"><img src="@/assets/images/quiz-star.svg" alt="" /></div>
      <div class="inner-card-content is-flex-grow-1">
        <p class="text">Your up score</p>
        <div class="score">
          <span>{{ upScore }}</span
          >/
          <span>100</span>
        </div>
      </div>
    </div>

    <div class="inner-card p-2" style="flex-direction: column;">
      <p
        class="is-flex is-align-items-center is-align-content-center"
        style="text-align: center;"
        @click="openReportQuestionModal=true"
      >
        <span><b>Report</b></span>
        <img
          style="margin-left: 10px;height: 20px; width: 20px;margin-top: 5px;"
          :src="require('@/assets/images/report.png')"
        />
      </p>
    </div>

    <b-modal
      :active="openReportQuestionModal"
      has-modal-card
      trap-focus
      :destroy-on-hide="true"
      aria-role="dialog"
      @close="toggleReportQuestionModal(false)"
      aria-modal
    >
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">
            <b>Report this Question</b>
          </p>
        </header>
        <section class="modal-card-body">
          <div class="columns is-multiline">
            <div class="column is-12">
                <b-input type="textarea" v-model="error_remarks"></b-input>
    <b-button @click="reportThisQuestion" class="mt-2 ml-0" type="is-dark"
      >Report</b-button
    >
              
            </div>
            
          </div>
        </section>
      </div>
    </b-modal>
    

    <!--Final Quiz Button-->
    <div v-if="quizOver" class="columns is-centered mt-1">
      <focus-button @clicked="submitThisQuiz" text="Submit Quiz"></focus-button>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import FocusButton from "@/components/FocusButton";
import StopWatch from "@/components/StopWatch";
const axios = require("@/utils/axios");
const { baseURL } = require("@/assets/js/config");
const $http = axios.create({ baseURL });

export default {
  name: "live-statistics",
  props: {
    currentQuestionId: String,
  },
  data() {
    return {
      time_elapsed: 0,
      is_stopwatch_stop: false,
      isLoading: false,
      error_remarks: "",
      openReportQuestionModal : false
    };
  },
  components: {
    FocusButton,
    StopWatch,
  },
  methods: {
    ...mapActions(["createQuizResponse"]),
    receiveStopWatchTime(time) {
      this.time_elapsed = time;
    },
    toggleReportQuestionModal(val){
        this.openReportQuestionModal = val
    },
    reportThisQuestion() {
      $http
        .post(
          "question-error",
          {
            url: `${window.location.href}?first_question=${this.currentQuestionId}`,
            remarks: this.error_remarks,
          },
          {
            headers: {
              "x-auth-token": this.getTeacherToken,
            },
          }
        )
        .then(() => {
          this.$buefy.toast.open({
            message: "Error Reported to the developer",
            type: "is-success",
          });
        })
        .finally(() => {
          this.error_remarks = "";
          this.openReportQuestionModal = false
        });
    },
    submitThisQuiz() {
      this.isLoading = true;
      //Stopping the stop watch
      this.is_stopwatch_stop = true;

      this.createQuizResponse({
        token: this.getTeacherToken,
        response: {
          skill: this.$route.params.skill_id,
          kid: this.$route.params.kid_id,
          summary: {
            upscore: this.upScore,
            time_taken: this.time_elapsed,
          },
        },
      })
        .then(() => {
          this.isLoading = false;
          this.$buefy.toast.open({
            message: "Quiz submitted successfully",
            type: "is-success",
          });
          this.$router.push({
            name: "kiddetail_category_skills",
            params: {
              id: this.$route.params.category_id,
            },
          });
        })
        .catch((err) => {
          this.isLoading = false;
          console.log(err);
          this.$buefy.toast.open({
            message: err?.response?.data,
            type: "is-danger",
          });
        });
    },
  },
  computed: {
    ...mapGetters([
      "getTeacherToken",
      "fetchColors",
      "fetchQuestionResponseMappings",
      "fetchQuestions",
    ]),
    uniqueQuestionsMappingForResponse(){
      // converting the mapping of index to question id
      let questionIdMapping = {};
      for (let question_index in this.fetchQuestionResponseMappings) {
        const mappingValue = this.fetchQuestionResponseMappings[question_index];
        questionIdMapping[mappingValue.question] = mappingValue;
      }

      return questionIdMapping
    },
    questionsCorrect() {
      // Unique questions correct
      let num = 0;
      
      const questionIdMapping = this.uniqueQuestionsMappingForResponse
      for (let question_index in questionIdMapping) {
        if (questionIdMapping[question_index].is_correct) {
          num++;
        }
      }

      return num;
    },
    questionsAnswered() {
      //Returns number of questions answered
      return Object.keys(this.fetchQuestionResponseMappings).length;
    },
    upScore() {
      let mapping = {};
      for (let q of this.fetchQuestions) {
        mapping[q._id] = 1;
      }
      return Math.round(
        (this.questionsCorrect / Object.keys(mapping).length) * 100
      );
    },
    quizOver() {
      return (
        this.questionsAnswered == this.fetchQuestions.length &&
        this.upScore == 100
      );
    },
  },
  created() {},
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@400;600;700&display=swap");

.inner-card {
  display: flex;
  align-items: center;
  background: #ffffff;
  position: relative;
  margin: 16px;
  padding: 16px;
  gap: 16px;
  border-radius: 12px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  border-left: 4px solid #31c7ff;
}

.inner-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}

.inner-card .svg {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f9ff;
  border-radius: 50%;
  padding: 10px;
}

.inner-card .svg img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.1));
}

.inner-card .inner-card-content {
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 8px;
}

.inner-card .inner-card-content .text {
  font-weight: 600;
  font-size: 0.85rem;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #666666;
}

.inner-card .inner-card-content div {
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 700;
  font-size: 1.5rem;
}

.inner-card .inner-card-content div span {
  color: #31c7ff;
}

.que-ans, .score {
  font-size: 1.6rem !important;
  font-weight: 700 !important;
  color: #333;
}

.que-ans span:first-child, .score span:first-child {
  color: #8919e7;
  font-size: 1.8rem;
}

.que-ans span:last-child, .score span:last-child {
  color: #666;
}

.columns.is-centered {
  margin-top: 20px !important;
}

.inner-card p[style*="text-align: center"] {
  cursor: pointer;
  color: #ff4757;
  font-weight: 600;
  font-size: 1rem;
  transition: color 0.2s ease;
  width: 100%;
  justify-content: center;
}

.inner-card p[style*="text-align: center"]:hover {
  color: #ff6b81;
}

.inner-card p[style*="text-align: center"] img {
  transition: transform 0.2s ease;
}

.inner-card p[style*="text-align: center"]:hover img {
  transform: scale(1.1);
}

.modal{
    z-index: 501;
}

.modal-card {
  margin: 0 10px;
  max-height: calc(100vh - 40px);
}

.modal-card-body {
  padding: 1rem;
}

/* Touch-friendly improvements */
.inner-card p[style*="text-align: center"] {
  min-height: 44px; /* iOS recommendation for touch targets */
  display: flex;
  align-items: center;
  justify-content: center;
}

@media screen and (max-width: 767px) {
  .inner-card {
    margin: 8px 4px;
    padding: 12px;
    gap: 12px;
    border-radius: 10px;
  }
  
  .inner-card .svg {
    width: 35px;
    height: 35px;
    padding: 8px;
  }
  
  .inner-card .inner-card-content {
    gap: 4px;
  }
  
  .inner-card .inner-card-content .text {
    font-size: 0.75rem;
    line-height: 1.2;
  }
  
  .inner-card .inner-card-content div {
    font-size: 1.2rem;
  }
  
  .que-ans, .score {
    font-size: 1.3rem !important;
  }
  
  .que-ans span:first-child, .score span:first-child {
    font-size: 1.5rem;
  }
  
  .inner-card p[style*="text-align: center"] {
    font-size: 0.9rem;
    padding: 8px;
    min-height: 40px;
  }
  
  .inner-card p[style*="text-align: center"] img {
    width: 16px !important;
    height: 16px !important;
    margin-left: 6px !important;
    margin-top: 2px !important;
  }
  
  .modal-card {
    margin: 0 5px;
    max-height: calc(100vh - 20px);
  }
  
  .modal-card-head {
    padding: 1rem;
  }
  
  .modal-card-body {
    padding: 0.75rem;
  }
  
  .modal-card-title {
    font-size: 1.1rem;
  }
  
  .columns.is-centered {
    margin-top: 15px !important;
  }
}

@media screen and (max-width: 480px) {
  .inner-card {
    margin: 6px 2px;
    padding: 10px;
    gap: 10px;
    border-radius: 8px;
  }
  
  .inner-card .svg {
    width: 30px;
    height: 30px;
    padding: 6px;
  }
  
  .inner-card .inner-card-content .text {
    font-size: 0.7rem;
  }
  
  .inner-card .inner-card-content div {
    font-size: 1.1rem;
  }
  
  .que-ans, .score {
    font-size: 1.2rem !important;
  }
  
  .que-ans span:first-child, .score span:first-child {
    font-size: 1.4rem;
  }
  
  .inner-card p[style*="text-align: center"] {
    font-size: 0.85rem;
    padding: 6px;
    min-height: 36px;
  }
  
  .modal-card {
    margin: 0 2px;
    max-height: calc(100vh - 10px);
  }
  
  .modal-card-head {
    padding: 0.75rem;
  }
  
  .modal-card-body {
    padding: 0.5rem;
  }
  
  .modal-card-title {
    font-size: 1rem;
  }
}

@media screen and (max-width: 360px) {
  .inner-card {
    margin: 4px 1px;
    padding: 8px;
    gap: 8px;
  }
  
  .inner-card .svg {
    width: 28px;
    height: 28px;
    padding: 5px;
  }
  
  .inner-card .inner-card-content .text {
    font-size: 0.65rem;
  }
  
  .inner-card .inner-card-content div {
    font-size: 1rem;
  }
  
  .que-ans, .score {
    font-size: 1.1rem !important;
  }
  
  .que-ans span:first-child, .score span:first-child {
    font-size: 1.3rem;
  }
  
  .inner-card p[style*="text-align: center"] {
    font-size: 0.8rem;
    padding: 4px;
    min-height: 32px;
  }
}
</style>
